import React from "react";
import { Link } from "react-router-dom";
import { CallIcon, StarIcon, WebIcon } from "../GlobalIcons";

import "./style.css";
import { HOMEIMAGES } from "../../constants/IMAGES";




const Footer = () => {
  const menuData = [
    {
      id: 1,
      Name: "Agent Registration",
      pageName: "agent-register"
    },
    {
      id: 2,
      Name: "Supplier Registration",
      pageName: "registration"
    },
    {
      id: 3,
      Name: "About Us",
      pageName: "about-us"

    },
    {
      id: 4,
      Name: " Contact Us",
      pageName: "contact-us"
    },
  ]


  const redirectToHotelPage = (pageName) => {
    const url = process.env.REACT_APP_TRP_HOTELS_URL;
    window.open(`${url}/${pageName}`, "_blank")
  }

  return (
    <div className="footer_sec">
      <div className="events_container">
        <div className="main_content">
          <div className="left_footer_section">
            <div className="logo_sec">
              <img src={HOMEIMAGES.LOGO} alt="Footer logo" />
            </div>
            <div className="menu_content">
              <h3>REGISTRATION</h3>
              <ul>
                {menuData?.map((item, index) => (
                  <li key={index} onClick={() => redirectToHotelPage(item?.pageName)} >
                    <Link>
                      <span>
                        <StarIcon />
                      </span>{" "}
                      {item.Name}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="mobile_call_icon">
                <CallIcon />
              </div>
            </div>
          </div>
          <div className="right_footer_section">
            <h2>NEWSLETTER</h2>
            <p>Subscribe to get our latest updates and offers</p>
            <div className="enter_email_sec">
              <input type="text" placeholder="Enter Your Email" />
              <button>SUBSCRIBE</button>
            </div>
          </div>
        </div>
      </div>

      <div className="contact_sec">
        <ul>
          <li>
            <Link>
              <span>
                <CallIcon />
              </span>
              +918800596344
            </Link>
          </li>
          <li>
            <Link>
              <span>
                <WebIcon />
              </span>
              support@trpworld.com
            </Link>
          </li>
        </ul>
      </div>

    </div>
  );
};

export default Footer;
